import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClient } from './api-client.service';

export interface GlobalSearchResultItem {
  itemType: 'member' | 'package' | 'membership' | 'invoice' | 'measurement';
  itemId: string;
  label: string;
  subLabel?: string | null;
}

@Injectable({ providedIn: 'root' })
export class GlobalSearchService {
  constructor(private readonly api: ApiClient) {}

  search(query: string, limit = 20, types?: string[]): Observable<GlobalSearchResultItem[]> {
    return this.api.get<GlobalSearchResultItem[]>('/api/search', {
      query,
      limit,
      ...(types && types.length > 0 ? { types: types.join(',') } : {})
    });
  }
}
